<template>
  <div id="app" :class="{ 'dark-mode': isDarkMode, 'mobile-view': isMobileView }">
    <Header />
    <div class="main-container">
      <Sidebar v-if="showSidebar" />
      <div class="content-container" :class="{ 'full-width': !showSidebar }">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './components/layout/Header.vue'
import Sidebar from './components/layout/Sidebar.vue'
import Footer from './components/layout/Footer.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    Header,
    Sidebar,
    Footer
  },
  data() {
    return {
      isMobileView: false
    }
  },
  computed: {
    ...mapGetters(['isDarkMode']),
    showSidebar() {
      // 在首页不显示侧边栏
      return this.$route.path !== '/'
    }
  },
  methods: {
    checkMobileView() {
      this.isMobileView = window.innerWidth <= 768;
    }
  },
  mounted() {
    this.checkMobileView();
    window.addEventListener('resize', this.checkMobileView);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobileView);
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.dark-mode {
  background-color: #1a1a2e;
  color: #f0f0f0;
}

.main-container {
  display: flex;
  flex: 1;
}

.content-container {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  transition: all 0.3s ease;
}

.full-width {
  width: 100%;
}

/* 全局过渡效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.dark-mode ::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.dark-mode ::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

/* 移动端样式 */
.mobile-view .content-container {
  padding: 15px;
}

/* 增加触摸目标大小 */
.mobile-view button,
.mobile-view a,
.mobile-view .el-button {
  min-height: 44px;
  min-width: 44px;
}

/* 移动端文本大小调整 */
@media (max-width: 768px) {
  body {
    font-size: 16px;
  }
  
  h1 {
    font-size: 24px;
  }
  
  h2 {
    font-size: 20px;
  }
  
  h3 {
    font-size: 18px;
  }
  
  .content-container {
    padding: 15px 10px;
  }
}

/* 平板样式 */
@media (min-width: 769px) and (max-width: 1024px) {
  .content-container {
    padding: 20px 15px;
  }
}
</style>
